<script lang="ts">
  import { onMount } from "svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import { init, record, save } from "./settings-general.store";

  /*
  $: canSubmit =
    $record != null &&
    $record.expirationWarningDays >= 0 &&
    !!$record.companyName;
  */
  $: canSubmit = $record != null;

  async function onSubmit() {
    await save();
  }

  onMount(init);
</script>

{#if $record != null}
  <!--
  <FormLayout on:submit={onSubmit} cancelEnabled={false} {canSubmit}>
    <FormField usageHelp="(200 caratteri)">
      <Input name="Denominazione Azienda" placeholder="denominazione" required={true} maxlength={200} bind:value={$record.companyName} />
    </FormField>

    <FormField usageHelp="giorni preavviso scadenza attività">
      <NumberInput name="Giorni Preavviso" placeholder="giorni preavviso" required={true} bind:value={$record.expirationWarningDays} />
    </FormField>

    <div class="columns">
      <div class="column is-2">
        <FormField usageHelp="applica ricarico dipendenti">
          <Switch name="Ricarico dipendenti" bind:value={$record.applyUserRevenue} />
        </FormField>
      </div>

      <div class="column is-10" style="margin-top: 1rem;">
        <div class="box">
          {#if $record.applyUserRevenue == 0}
            Il costo delle attività è determinato in base ai prezzi inseriti.
          {:else}
            Il costo delle attività è determinato dal costo orario dipendente sommato al ricarico orario.
          {/if}
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-2">
        <FormField usageHelp="permetti tipi attività specifici">
          <Switch name="Tipi attività specifici" bind:value={$record.dossierActivities} />
        </FormField>
      </div>

      <div class="column is-10" style="margin-top: 1rem;">
        <div class="box">
          {#if $record.dossierActivities == 0}
            Le tipologie delle attività sono generiche ed applicabili a tutti i tipi di pratica.
          {:else}
            Le tipologie di attività sono sia generiche (applicabili a tutti i tipi di pratica) che specifiche per alcuni tipi di pratica.
          {/if}
        </div>
      </div>
    </div>
  </FormLayout>
-->
{/if}
